<fs-sidenav-menu-items>
  <button fs-sidenav-menu-item (click)="switchParent()">Switch to parent experience</button>
</fs-sidenav-menu-items>